/* PERFETTO */
function apriCarrello(){
  document.getElementById('carrello')?.classList.add('open');
  document.getElementById('velo')?.classList.add('on');
  document.body.style.overflow='hidden';
}
function chiudiCarrello(){
  document.getElementById('carrello')?.classList.remove('open');
  document.getElementById('velo')?.classList.remove('on');
  document.body.style.overflow='';
}

/* ---- CAROSELLO ---- */
let carI=0;
function carA(i){
  const t=document.getElementById('car-track');
  if(!t)return;
  const n=t.children.length;
  carI=(i+n)%n;
  t.style.transform=`translateX(-${carI*100}%)`;
  document.querySelectorAll('.car-p').forEach((p,k)=>p.classList.toggle('on',k===carI));
  document.querySelectorAll('.mini').forEach((m,k)=>m.classList.toggle('on',k===carI));
}
function carVai(d){carA(carI+d)}

/* swipe su mobile */
document.addEventListener('DOMContentLoaded',()=>{
  const car=document.querySelector('.car');
  if(car){
    let x0=null;
    car.addEventListener('touchstart',e=>{x0=e.touches[0].clientX},{passive:true});
    car.addEventListener('touchend',e=>{
      if(x0===null)return;
      const dx=e.changedTouches[0].clientX-x0;
      if(Math.abs(dx)>45)carVai(dx<0?1:-1);
      x0=null;
    },{passive:true});
  }

  /* menu mobile */
  const ham=document.getElementById('ham');
  const mn=document.getElementById('mn');
  if(ham&&mn){
    if(!mn.querySelector('.cart-mob')){
      const b=document.createElement('button');
      b.className='cart-mob';
      b.textContent='Carrello ('+(document.querySelector('.n-carrello')?.textContent||0)+')';
      b.onclick=()=>{mn.classList.remove('open');ham.classList.remove('on');document.body.style.overflow='';apriCarrello()};
      mn.appendChild(b);
    }
    ham.addEventListener('click',()=>{
      const on=mn.classList.toggle('open');
      ham.classList.toggle('on',on);
      ham.setAttribute('aria-expanded',on);
      document.body.style.overflow=on?'hidden':'';
    });
  }

  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'){chiudiCarrello();mn?.classList.remove('open');ham?.classList.remove('on');document.body.style.overflow=''}
    if(document.querySelector('.car')){
      if(e.key==='ArrowLeft')carVai(-1);
      if(e.key==='ArrowRight')carVai(1);
    }
  });
});

/* quantità carrello */
function qtyStep(btn,d){
  const inp=d<0?btn.nextElementSibling:btn.previousElementSibling;
  const v=Math.max(0,parseInt(inp.value||0)+d);
  inp.value=v;
  inp.form.submit();
}

/* varianti prodotto */
document.addEventListener('change',e=>{
  if(!e.target.matches('.variant-radios input'))return;
  const form=e.target.closest('form');
  if(!form||!window.__variants)return;
  const sel=[...form.querySelectorAll('.variant-radios input:checked')].map(i=>i.value);
  const v=window.__variants.find(x=>x.options.every((o,i)=>o===sel[i]));
  const hidden=form.querySelector('.variant-id');
  const btn=form.querySelector('.add');
  if(v&&hidden){
    hidden.value=v.id;
    if(btn){btn.disabled=!v.available;btn.textContent=v.available?'Aggiungi al carrello':'Esaurito'}
  }
});
